import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useState } from 'react';

const EditPreferRelationShip = () => {
  const RELATIONSHIP_OPTIONS = [
    { label: brsc.relationship_label_serious_friend, value: 'serious_friend' },
    { label: brsc.relationship_label_casual_chat, value: 'casual_chat' },
    { label: brsc.relationship_label_global_penpal, value: 'global_penpal' },
    { label: brsc.relationship_label_just_browsing, value: 'just_browsing' },
  ];

  const [selectedRelationship, setSelectedRelationship] = useState<string | undefined>();
  const { sheets, closeWithAnimation } = useBottomSheet();
  const sheet = sheets.EditPreferRelationShip;

  const handleSelectRelationship = (value: string) => {
    setSelectedRelationship(value);
  };

  useEffect(() => {
    const myRelationship = myinfo.signup_preference?.preferRelationship;
    if (myRelationship) {
      setSelectedRelationship(myRelationship);
    }
  }, []);

  useEffect(() => {
    if (selectedRelationship && selectedRelationship !== myinfo.signup_preference?.preferRelationship) {
      // 구계정은 signup_preference 객체 자체가 없을 수 있어 스프레드로 안전하게 생성/갱신
      myinfo.signup_preference = { ...myinfo.signup_preference, preferRelationship: selectedRelationship };
      MyDataManager.save('signup_preference');

      setTimeout(() => {
        closeWithAnimation(sheet.id);
      }, 100);
    }
  }, [selectedRelationship, sheet.id, closeWithAnimation]);

  return (
    <div className="z-10 w-full">
      <div className="flex flex-col gap-4">
        {RELATIONSHIP_OPTIONS.map((option) => (
          <div
            onClick={() => handleSelectRelationship(option.value)}
            key={option.value}
            data-value={option.value}
            className="relationship-item bg-base-bg-subtle flex w-full items-center justify-center gap-2 rounded-lg px-4 py-6 typography-headline-md"
            dangerouslySetInnerHTML={{ __html: option.label }}
            style={{
              backgroundColor: selectedRelationship === option.value ? 'var(--bcs-semantic-base-bg-focus)' : 'var(--bcs-semantic-base-bg-subtle)',
              color: selectedRelationship === option.value ? 'var(--bcs-semantic-base-txt-purple)' : 'var(--bcs-semantic-base-txt-primary)',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default EditPreferRelationShip;
